module.exports = __webpack_public_path__ + "static/media/02․05․-1.382ac2d9.webp";